import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import axios from 'axios'
import 'moment-timezone'
import {listAllAnswers} from '../../actions/answerActions'
import AdminAnswersList from '../../components/AdminAnswersList.js'
import Loader from '../../components/Loader.js'
import AdminResultDetailsList from '../../components/AdminResultDetailsList.js'

const AdminAnswersScreen = ({history}) => {
    const dispatch = useDispatch()
    const [selectedAnswers, setSelectedAnswers] = useState([])
    const [printLoading, setPrintLoading] = useState(false)
    const [printError, setPrintError] = useState(null)
    const [showPrintPreview, setShowPrintPreview] = useState(false)
    const [selectedAnswerResults, setSelectedAnswerResults] = useState([])
    const [fetchAllLoading, setFetchAllLoading] = useState(false)
    const [fetchAllProgress, setFetchAllProgress] = useState({ loaded: 0, total: 0 })

    const {userInfo} = useSelector((state) => state.user)
    const {loading, answers = [], error} = useSelector(
        (state) => state.answerAdminList
    )

    useEffect(() => {
        dispatch(listAllAnswers())
    }, [dispatch])

    const selectAnswers = () => {
        if (answers.length === 0) {
            return answers
        }

        return answers
    }

    const handlePrintSelected = async () => {
        if (selectedAnswers.length === 0) {
            return
        }
        setPrintLoading(true)
        setPrintError(null)
        setSelectedAnswerResults([]) // Clear previous details
        try {
            const {data} = await axios.post(`${process.env.REACT_APP_API_URL}/api/admin/answers/get-answers`,
                {answerIds: selectedAnswers},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${userInfo.token}`
                    }
                }
            )
            if (data.length === 0) {
                setPrintError('Não foi encontrada nenhuma resposta para os IDs selctionados')
            } else {
                setSelectedAnswerResults(data)
                setShowPrintPreview(true)
            }
        } catch (error) {
            setPrintError('Error fetching answers for printing.')
        } finally {
            setPrintLoading(false)
        }
    }

    // Fetch all answers in batches from paginated endpoint
    const handleFetchAllAnswers = async () => {
        setFetchAllLoading(true)
        setPrintError(null)
        setSelectedAnswerResults([])
        try {
            const limit = 100 // batch size
            let page = 1
            let allAnswers = []
            let total = 0
            let keepFetching = true
            while (keepFetching) {
                const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/answers/paginated`, {
                    params: { page, limit },
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${userInfo.token}`
                    }
                })
                if (data && data.answers) {
                    allAnswers = allAnswers.concat(data.answers)
                    total = data.total
                    setFetchAllProgress({ loaded: allAnswers.length, total })
                    if (allAnswers.length >= total) {
                        keepFetching = false
                    } else {
                        page += 1
                    }
                } else {
                    keepFetching = false
                }
            }
            if (allAnswers.length === 0) {
                setPrintError('Não foi encontrada nenhuma resposta.')
            } else {
                setSelectedAnswerResults(allAnswers)
                setShowPrintPreview(true)
            }
        } catch (error) {
            setPrintError('Erro ao buscar todas as respostas para impressão.')
        } finally {
            setFetchAllLoading(false)
            setFetchAllProgress({ loaded: 0, total: 0 })
        }
    }

    const handleCheckboxChange = (answerId) => {
        setSelectedAnswers((prevSelected) =>
            prevSelected.includes(answerId)
                ? prevSelected.filter((id) => id !== answerId)
                : [...prevSelected, answerId]
        )
    }

    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            const allAnswerIds = selectAnswers().map((answer) => answer.id)
            setSelectedAnswers(allAnswerIds)
        } else {
            setSelectedAnswers([])
        }
    }

    const allSelected = selectedAnswers.length === selectAnswers().length && selectAnswers().length > 0
    const indeterminate = selectedAnswers.length > 0 && selectedAnswers.length < selectAnswers().length

    return <>
        {loading ?
            <Loader/> :
            showPrintPreview ?
                <AdminResultDetailsList
                    answers={selectedAnswerResults}
                    handleBackButton={(e) => {
                        e.preventDefault()
                        setShowPrintPreview(false)
                    }}
                /> :
                <>
                    <AdminAnswersList
                        handlePrintSelected={handlePrintSelected}
                        selectedAnswers={selectedAnswers}
                        printLoading={printLoading}
                        printError={printError}
                        handleSelectAllChange={handleSelectAllChange}
                        error={error}
                        allSelected={allSelected}
                        handleCheckboxChange={handleCheckboxChange}
                        selectAnswers={selectAnswers}
                        indeterminate={indeterminate}
                        handleFetchAllAnswers={handleFetchAllAnswers}
                        fetchAllLoading={fetchAllLoading}
                        fetchAllProgress={fetchAllProgress}
                        answers={answers}
                    />
                </>
        }
    </>
}

export default AdminAnswersScreen
